import * as React from 'react';
import { css } from '@emotion/core';
import MobileToolbar from '../../layout/mobile/MobileToolbar';
import { Str } from '../../localization/translationKeys';
import { faBook, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Routes } from '../../navigation/routes';
import Msg from '../../localization/Msg';
import { FLEX_COLUMN, FLEX_CENTERED } from '../../layout/flexBox';
import { BTN_HOVER } from '../../forms/styles/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spacer from '../../layout/Spacer';
import { COLORS } from '../../globalStyle/colors';
import { useAppState } from '../../core/redux/hooks';


const ACTION_BTN = css`
  width: 100px;
  height: 100%;
  font-size: 9px;
  text-decoration: none;
  text-align: center;
  overflow-wrap: break-spaces;
  text-transform: uppercase;
  box-sizing: border-box;
  transition: all .2s ease;
`;

const styles = {
  root:           css`
    
  `,
  icon:           css`
    font-size: 22px;
  `,
  devResourceBtn: [
    FLEX_COLUMN,
    FLEX_CENTERED,
    ACTION_BTN,
    BTN_HOVER,
    css`
      color: ${COLORS.DARK_GREY};
    `,
  ],
  addBtn:         [
    FLEX_COLUMN,
    FLEX_CENTERED,
    ACTION_BTN,
    BTN_HOVER,
    css`
      border: none !important;
      background-color: ${COLORS.BLUE};
      color: ${COLORS.WHITE};
    `,
  ],
};


type Props = {
  routes: Routes;
  onClickToAdd: () => void;
  className?: string;
};


/**
 * MobileDevPlanItemActions: a component that renders a bar at the bottom of the screen with Dev Resources and Add Action
 * buttons.
 */
const MobileDevPlanItemActions: React.FC<Props> = props => {
  const hasDevResources = useAppState(state => !!state.devResources?.length);

  return (
    <MobileToolbar css={styles.root} className={props.className}>
      {
        hasDevResources && (
          <Link to={props.routes.DevResources_DevPlan} css={styles.devResourceBtn}>
            <FontAwesomeIcon icon={faBook} size={'lg'} css={styles.icon} />
            <Spacer sizePx={8} />
            <Msg str={Str.DevResources} />
          </Link>
        )
      }
      <button onClick={props.onClickToAdd} css={styles.addBtn}>
        <FontAwesomeIcon icon={faPlus} size={'lg'} css={styles.icon} />
        <Spacer sizePx={8} />
        <Msg str={Str.AddAction} />
      </button>
    </MobileToolbar>
  );
};

export default MobileDevPlanItemActions;
